export const DATA_ATTRIBUTES = {
  enterIndex: 'data-enterindex',
} as const
